if (!customElements.get('side-arrow-slider')) {
  customElements.define(
    'side-arrow-slider',
    class SideArrowSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.sectionId = this.dataset.sectionId;

        this.swiperEl = this.querySelector('.swiper');
        this.prevBtn = this.querySelector('.sas-arrow--prev');
        this.nextBtn = this.querySelector('.sas-arrow--next');
        this.paginationEl = this.querySelector('.sas-pagination');

        if (!this.enableSlider || !this.swiperEl) return;

        this.initSlider();

        // Re-init when the section is updated in the theme editor
        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:section:load', this.onSectionLoad.bind(this));
          document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
        }
      }

      disconnectedCallback() {
        if (this.swiperInstance && this.swiperInstance.slider) {
          try { this.swiperInstance.slider.destroy(true, true); } catch (_) {}
        }
      }

      initSlider() {
        const autoplayDelay = parseInt(this.dataset.autoplay, 10);

        const modules = [];
        if (window.FoxTheme && FoxTheme.Swiper) {
          if (FoxTheme.Swiper.Autoplay) modules.push(FoxTheme.Swiper.Autoplay);
          if (FoxTheme.Swiper.EffectFade) modules.push(FoxTheme.Swiper.EffectFade);
        }

        const options = {
          slidesPerView: 1,
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          threshold: 2,
          effect: 'fade',
          fadeEffect: { crossFade: true },
        };

        if (this.prevBtn && this.nextBtn) {
          options.navigation = {
            nextEl: this.nextBtn,
            prevEl: this.prevBtn,
          };
        }

        if (this.paginationEl) {
          options.pagination = {
            el: this.paginationEl,
            clickable: true,
          };
        }

        if (autoplayDelay > 0) {
          options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }

        if (window.FoxTheme && FoxTheme.Carousel) {
          this.swiperInstance = new FoxTheme.Carousel(this.swiperEl, options, modules);
          this.swiperInstance.init();
        }
      }

      onSectionLoad(event) {
        if (event.detail && event.detail.sectionId === this.sectionId) {
          this.initSlider();
        }
      }

      onBlockSelect(event) {
        if (!this.swiperInstance || !this.swiperInstance.slider) return;
        if (event.detail && event.detail.sectionId !== this.sectionId) return;
        const index = Number(event.target.dataset.index);
        if (Number.isFinite(index)) {
          this.swiperInstance.slider.slideToLoop(index);
        }
      }
    }
  );
}
